import React from 'react';
import Modal from '../../../Components/Modal';
import Form, { Actions, Radio } from '../../../Components/Form';
import { usePreference } from '../../../Data/Preference';
import {
    DEFAULT_DAILY_TRACKER_GROUP_BY,
    DEFAULT_DAILY_TRACKER_ROW_END_METRIC,
} from './weekOverviewHelper';

const DailyTrackerPreferences = ({isOpen, setIsOpen}) => {
    return <Modal title="Daily tracker preferences" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>
        {isOpen && <Inner />}
    </Modal>
}

const Inner = () => {
    const [groupBy, setGroupBy] = usePreference('dailyTracker:groupBy', DEFAULT_DAILY_TRACKER_GROUP_BY);
    const [rowEndMetric, setRowEndMetric] = usePreference('dailyTracker:rowEndMetric', DEFAULT_DAILY_TRACKER_ROW_END_METRIC);

    const data = {
        groupBy,
        rowEndMetric,
    };

    const save = (d) => {
        setGroupBy(d.groupBy);
        setRowEndMetric(d.rowEndMetric);
    };

    return <Form data={data} onSubmit={save} closeModalOnSubmit>
        <Radio
            name="groupBy"
            label="Group rows by"
            options={[
                {label: 'Worker', value: 'assignedTo'},
                {label: 'Round', value: 'roundId'},
            ]}
        />
        <Radio
            name="rowEndMetric"
            label="Grouping summary metric"
            options={[
                {label: 'Jobs', value: 'jobs'},
                {label: 'Duration', value: 'duration'},
                {label: 'Cost', value: 'cost'},
            ]}
        />
        <Actions submit={{label: 'Save'}} />
    </Form>
}

export default DailyTrackerPreferences;
